export default __webpack_public_path__ + "static/media/expand_left.d2e26251.svg";